const mutations = {
  SET_IS_LOADING (state, isLoading) {
    state.isLoading = isLoading
  },

  SET_PLATFORM_ACTIONS (state, platformActions) {
    state.platformActions = platformActions
  },

  SET_PLATFORM_PLUGINS (state, platformPlugins) {
    state.platformPlugins = platformPlugins
  },

  SET_PLATFORM_ATTRIBUTES (state, platformAttributes) {
    state.platformAttributes = platformAttributes
  },

  SET_IS_LOADING_PLATFORM_PLUGINS (state, isLoading) {
    state.isLoadingPlatformPlugins = isLoading
  },

  SET_PAGE_FILTER (state, pageFilter) {
    state.pageFilter = Object.assign({}, state.pageFilter, pageFilter)
  },

  SET_IS_PAGE_FILTER_EXCEPTION_CSAT (state, isPageFilterExceptionCsat) {
    state.isPageFilterExceptionCsat = isPageFilterExceptionCsat
  },

  SET_IS_PAGE_FILTER_EXCEPTION_FEELING (state, isPageFilterExceptionFeeling) {
    state.isPageFilterExceptionFeeling = isPageFilterExceptionFeeling
  },

  SET_IS_PAGE_FILTER_EXCEPTION_STATUS (state, isPageFilterExceptionStatus) {
    state.isPageFilterExceptionStatus = isPageFilterExceptionStatus
  },

  SET_SHOW_PAGE_FILTER_BAR (state, showPageFilterBar) {
    state.showPageFilterBar = showPageFilterBar
  }
}

export default mutations
